import { render, staticRenderFns } from "./CardHistoryLog.vue?vue&type=template&id=97c9920a&scoped=true"
import script from "./CardHistoryLog.vue?vue&type=script&lang=js"
export * from "./CardHistoryLog.vue?vue&type=script&lang=js"
import style0 from "./CardHistoryLog.vue?vue&type=style&index=0&id=97c9920a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c9920a",
  null
  
)

export default component.exports